export const handleChange = (e, newGames, setNewGames, isNumeric = false) => {
  const value = isNumeric ? parseInt(e.target.value, 10) : e.target.value;
  setNewGames({ ...newGames, [e.target.name]: value });
};

export const handleSubmit = (e, createGames, newGames, setNewGames, setSnackbar) => {
  e.preventDefault();
  createGames({ variables: { input: newGames } });
};

export const handleCloseSnackbar = (setSnackbar, snackbar) => {
  setSnackbar({ ...snackbar, open: false });
};

export const handleChangePage = (event, newPage, setPage) => {
  setPage(newPage);
};

export const handleChangeRowsPerPage = (event, setRowsPerPage, setPage) => {
  setRowsPerPage(+event.target.value);
  setPage(0);
};